export const FIREBASE_PRODUCTION_PROJECT_ID = 'fancian-production';

export const DEFAULT_FIREBASE_CRASHLYTICS_URL =
  `https://console.firebase.google.com/project/${FIREBASE_PRODUCTION_PROJECT_ID}/crashlytics`;

export function getFirebaseCrashlyticsUrl(configuredUrl) {
  return configuredUrl?.trim() || DEFAULT_FIREBASE_CRASHLYTICS_URL;
}
